<template>
    <div :class="classNames">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'Steps',
    props: {
        active: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            classNames: 'steps_wrap'
        }
    },
    created() {
        this.$nextTick(() => {
            this.changeSlots()
        })
    },
    methods: {
        changeSlots() {
            let slotsList = this.$slots.default
            if(slotsList && slotsList.length) {
                slotsList[slotsList.length - 1].componentInstance.$refs.line.style.display="none"
                for (const [index, item] of slotsList.entries()) {
                    let dom = item.componentInstance.$refs.line
                    let status = item.componentInstance.status
                    if(index + 1 < this.active) {
                        dom.style.background = '#1677FF'
                    }
                    if(status == 'error') {
                        slotsList[index - 1].componentInstance.$refs.line.style.background = '#EA4B4B'
                    }
                }
            }
        }
    },
    watch: {
        active(news) {
            this.$nextTick(() => {
                this.changeSlots()
            })
        }
    }
}
</script>
<style lang="less" scoped>
    @classNames: steps_wrap;
    .@{classNames} {
        
    }
</style>